/* rails-erb-loader-dependencies ../config/routes */
/**
 * @file Generated by js-routes 2.3.5. Based on Rails 7.2.2.1 routes of Elvium::Application.
 * @version a100fd3edb1c2839f176a4954bd4b43108204ed8b777097ec5bf907c7b8ac799
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
window.Routes = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using window.Routes = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {"locale":"en"},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("NIL", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{
  /**
   * Generates rails route to
   * (/:locale)/edit_requests/:id/accept_request(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  accept_request_edit_request_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"edit_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/review/:id/add_comment(.:format)
   * @param {any} employees_datum_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_comment_hr_employees_datum_review_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/positions/:id/add_demo_candidates(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_demo_candidates_admin_position_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_demo_candidates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/add_demo_candidates(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_demo_candidates_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_demo_candidates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/applications/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_application_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/application_approaches(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_application_approaches_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_approaches"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/applications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_applications_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/documents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_documents_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/hr_employees/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_hr_employee_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hr_employees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/hr_employees(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_hr_employees_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hr_employees"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/positions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_position_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/position_tags/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_position_tag_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"position_tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/position_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_position_tags_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"position_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/positions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_positions_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"positions"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/recruiters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_recruiters_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recruiters"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_root_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /admin/tags/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_tag_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  admin_tags_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /swagger/
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_docs_root_path: __jsr.r({}, [2,[2,[7,"/"],[6,"swagger"]],[7,"/"]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/comments/:id(.:format)
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  application_comment_path: __jsr.r({"locale":{},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/comments(.:format)
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  application_comments_path: __jsr.r({"locale":{},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/application_process_customization(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  application_process_customization_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"application_process_customization"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/tags/:id(.:format)
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  application_tag_path: __jsr.r({"locale":{},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/tags(.:format)
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  application_tags_path: __jsr.r({"locale":{},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/application_transfers/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  application_transfer_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"application_transfers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboardings/:id/archive(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  archive_hr_onboarding_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/archive(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  archive_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/archived(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  archived_positions_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/comments/:id(.:format)
   * @param {any} artificial_candidate_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  artificial_candidate_comment_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/comments(.:format)
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  artificial_candidate_comments_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/tags/:id(.:format)
   * @param {any} artificial_candidate_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  artificial_candidate_tag_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/tags(.:format)
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  artificial_candidate_tags_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_saved_profiles/:artificial_saved_profile_id/comments/:id(.:format)
   * @param {any} artificial_saved_profile_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  artificial_saved_profile_comment_path: __jsr.r({"locale":{},"artificial_saved_profile_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_saved_profiles"],[2,[7,"/"],[2,[3,"artificial_saved_profile_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_saved_profiles/:artificial_saved_profile_id/comments(.:format)
   * @param {any} artificial_saved_profile_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  artificial_saved_profile_comments_path: __jsr.r({"locale":{},"artificial_saved_profile_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_saved_profiles"],[2,[7,"/"],[2,[3,"artificial_saved_profile_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/tags/assign(.:format)
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assign_application_tags_path: __jsr.r({"locale":{},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/tags/assign(.:format)
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assign_artificial_candidate_tags_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/assign_document_folder(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assign_document_folder_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_document_folder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/assign_tags(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assign_tags_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/attach_document(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  attach_document_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_document"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/attachments/preview(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  attachments_preview_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/availability_dates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  availability_date_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"availability_dates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/availability_dates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  availability_dates_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"availability_dates"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * /admin/application_approaches/batch_action(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_action_admin_application_approaches_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"application_approaches"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/applications/batch_action(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_action_admin_applications_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/documents/batch_action(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_action_admin_documents_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/hr_employees/batch_action(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_action_admin_hr_employees_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hr_employees"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/position_tags/batch_action(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_action_admin_position_tags_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"position_tags"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/positions/batch_action(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_action_admin_positions_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/recruiters/batch_action(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_action_admin_recruiters_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"recruiters"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/tags/batch_action(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_action_admin_tags_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"batch_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/batch_applications(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_applications_position_recruiters_applications_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"batch_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/batch_extra_data(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_extra_data_position_recruiters_applications_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"batch_extra_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/hr_employees/:id/become(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  become_admin_hr_employee_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hr_employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"become"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/feedback_forms/:id/brief(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  brief_feedback_form_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"feedback_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"brief"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/c/id/candidate/:id/:secret(.:format)
   * @param {any} id
   * @param {any} secret
   * @param {object | undefined} options
   * @returns {string} route path
   */
  calendar_candidate_interview_date_path: __jsr.r({"locale":{},"id":{"r":true},"secret":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"id"],[2,[7,"/"],[2,[6,"candidate"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"secret"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/c/id/mine/:secret(.:format)
   * @param {any} secret
   * @param {object | undefined} options
   * @returns {string} route path
   */
  calendar_mine_interview_dates_path: __jsr.r({"locale":{},"secret":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"id"],[2,[7,"/"],[2,[6,"mine"],[2,[7,"/"],[2,[3,"secret"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/c/id/org/:secret(.:format)
   * @param {any} secret
   * @param {object | undefined} options
   * @returns {string} route path
   */
  calendar_organization_interview_dates_path: __jsr.r({"locale":{},"secret":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"id"],[2,[7,"/"],[2,[6,"org"],[2,[7,"/"],[2,[3,"secret"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/c/id/show(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  calendar_show_ics_interview_dates_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"id"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/hr_employees/:id/cancel_invitation(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_invitation_admin_hr_employee_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hr_employees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:id/cancel_invitation(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_invitation_hr_person_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/cancel_pending(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_pending_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_pending"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/cancel_pending(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_pending_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_pending"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_documents/:id/candidate_copy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  candidate_copy_contract_document_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"candidate_copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /(:locale)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  candidate_root_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[1,[3,"locale"]],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/candidates/document_requests(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  candidates_document_requests_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"candidates"],[2,[7,"/"],[2,[6,"document_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/catalyst_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  catalyst_integration_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"catalyst_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/catalyst_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  catalyst_integration_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"catalyst_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  categories_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  category_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/artificial_saved_profiles/:id(.:format)
   * @param {any} category_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  category_artificial_saved_profile_path: __jsr.r({"locale":{},"category_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"artificial_saved_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/saved_profiles/:id(.:format)
   * @param {any} category_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  category_saved_profile_path: __jsr.r({"locale":{},"category_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/saved_profiles(.:format)
   * @param {any} category_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  category_saved_profiles_path: __jsr.r({"locale":{},"category_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_role_profiles/:id/change_family(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  change_family_hr_talent_role_profile_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_role_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_family"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/change_file_visibility(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  change_file_visibility_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_file_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/change_hide_rejected(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  change_hide_rejected_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_hide_rejected"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/change_mark(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  change_mark_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_mark"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/change_mark(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  change_mark_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_mark"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/change_maybe_flag(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  change_maybe_flag_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_maybe_flag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/change_maybe_flag(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  change_maybe_flag_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_maybe_flag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:id/change_owner(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  change_owner_hr_person_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_owner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/saved_profiles/:id/chat(.:format)
   * @param {any} category_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  chat_category_saved_profile_path: __jsr.r({"locale":{},"category_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/check_email_uniqueness(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  check_email_uniqueness_hr_employees_data_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[6,"check_email_uniqueness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/check_internal_id_uniqueness(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  check_internal_id_uniqueness_hr_employees_data_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[6,"check_internal_id_uniqueness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/application_transfer_operations/check_transfer_conditions(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  check_transfer_conditions_position_application_transfer_operations_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"application_transfer_operations"],[2,[7,"/"],[2,[6,"check_transfer_conditions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/checklists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  checklist_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"checklists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/checklist_evaluations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  checklist_evaluation_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"checklist_evaluations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/checklist_evaluations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  checklist_evaluations_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"checklist_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/checklist_task_evaluations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  checklist_task_evaluation_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"checklist_task_evaluations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/checklists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  checklists_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"checklists"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/clone_position(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  clone_position_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/close_position(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  close_position_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/closed(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  closed_positions_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"closed"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/communicate_all(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  communicate_all_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"communicate_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/:id/confirm_destroy(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_destroy_position_candidates_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/:id/confirm_keeping(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_keeping_position_candidates_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_keeping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_documents/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  contract_document_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_documents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  contract_documents_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_documents"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_requests/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  contract_request_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_requests(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  contract_requests_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_requests"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/create_from_excel(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  create_from_excel_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"create_from_excel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/create_from_pdf(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  create_from_pdf_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"create_from_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/create_profile(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  create_profile_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"create_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:id/create_subcategory(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  create_subcategory_category_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_subcategory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/custom_contract_tags/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  custom_contract_tag_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_contract_tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/custom_contract_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  custom_contract_tags_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_contract_tags"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * /
   * @param {object | undefined} options
   * @returns {string} route path
   */
  custom_domain_root_path: __jsr.r({}, [7,"/"]),

  /**
   * Generates rails route to
   * (/:locale)/hr/surveys/dashboard(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  dashboard_hr_surveys_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/candidates/:id/delete_application(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_application_admin_candidate_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/review/:id/delete_comment(.:format)
   * @param {any} employees_datum_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_comment_hr_employees_datum_review_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/delete_file(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_file_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/delete_photo(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_photo_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/position_approaches/destroy_all(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_all_position_candidates_position_approaches_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"position_approaches"],[2,[7,"/"],[2,[6,"destroy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/documents/destroy_cache(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_cache_documents_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"destroy_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/destroy_document/:document_id(.:format)
   * @param {any} id
   * @param {any} document_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_document_position_path: __jsr.r({"locale":{},"id":{"r":true},"document_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_document"],[2,[7,"/"],[2,[3,"document_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees/sign_out(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_hr_employee_session_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobnet_publication/destroy_logo(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_logo_position_jobnet_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobnet_publication"],[2,[7,"/"],[2,[6,"destroy_logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/destroy_photo(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_photo_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/documents/:id/destroy_requested(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_requested_position_recruiters_application_document_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_requested"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/documents/:id/destroy_requested(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_requested_position_recruiters_artificial_candidate_document_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_requested"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/statistics/digital_marketing(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  digital_marketing_statistics_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"digital_marketing"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/discard_remaining(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  discard_remaining_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard_remaining"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/artificial_saved_profiles/:id/documents(.:format)
   * @param {any} category_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  documents_category_artificial_saved_profile_path: __jsr.r({"locale":{},"category_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"artificial_saved_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/saved_profiles/:id/documents(.:format)
   * @param {any} category_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  documents_category_saved_profile_path: __jsr.r({"locale":{},"category_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/documents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  documents_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/documents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  documents_hr_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/documents_status(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  documents_status_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/documents_status(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  documents_status_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"documents_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/surveys/:id/download_action_plan(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_action_plan_hr_survey_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_action_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/download_contract(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_contract_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications_summaries/:id/download(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_position_recruiters_applications_summary_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications_summaries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/surveys/:id/download_results(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_results_hr_survey_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/drafts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  draft_positions_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"drafts"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * /admin/positions/:id/duplicate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  duplicate_admin_position_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/checklists/:id/duplicate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  duplicate_checklist_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"checklists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboarding_templates/:id/duplicate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  duplicate_hr_onboarding_template_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboarding_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_role_profiles/:id/duplicate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  duplicate_hr_talent_role_profile_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_role_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/positions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_admin_position_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/position_tags/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_admin_position_tag_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"position_tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/tags/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_admin_tag_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/comments/:id/edit(.:format)
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_application_comment_path: __jsr.r({"locale":{},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/application_process_customization/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_application_process_customization_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"application_process_customization"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/tags/:id/edit(.:format)
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_application_tag_path: __jsr.r({"locale":{},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/application_transfers/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_application_transfer_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"application_transfers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/comments/:id/edit(.:format)
   * @param {any} artificial_candidate_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_artificial_candidate_comment_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/tags/:id/edit(.:format)
   * @param {any} artificial_candidate_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_artificial_candidate_tag_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_saved_profiles/:artificial_saved_profile_id/comments/:id/edit(.:format)
   * @param {any} artificial_saved_profile_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_artificial_saved_profile_comment_path: __jsr.r({"locale":{},"artificial_saved_profile_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_saved_profiles"],[2,[7,"/"],[2,[3,"artificial_saved_profile_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/edit_brief(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_brief_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_brief"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/edit_brief(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_brief_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_brief"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_category_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/checklists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_checklist_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"checklists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_documents/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_contract_document_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/custom_contract_tags/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_custom_contract_tag_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_contract_tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/feedback_forms/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_feedback_form_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"feedback_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_documents/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_contract_document_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/custom_contract_tags/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_custom_contract_tag_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"custom_contract_tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/departments/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_department_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employee_contract_fills/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_employee_contract_fill_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employee_contract_fills"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees/password/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_employee_password_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/fields_configuration/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_fields_configuration_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"fields_configuration"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboardings/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_onboarding_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboarding_templates/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_onboarding_template_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboarding_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/organizations/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_organization_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/permissions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_permission_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_person_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/review_templates/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_review_template_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"review_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/teams/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_hr_team_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/rounds/edit_interview_time(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_interview_time_position_rounds_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"rounds"],[2,[7,"/"],[2,[6,"edit_interview_time"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/edit_media_module_settings(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_media_module_settings_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_media_module_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/organizations/:organization_id/saved_profiles/:id/edit(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_organization_saved_profile_path: __jsr.r({"locale":{},"organization_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/application_transfer_operations/:id/edit(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_application_transfer_operation_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"application_transfer_operations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/candidate_email/edit(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_candidate_email_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"candidate_email"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/:id/edit(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_candidates_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/email_customizations/:id/edit(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_email_customization_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"email_customizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_reminders/:id/edit(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_interview_reminder_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_reminders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/job_posting/edit(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_job_posting_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"job_posting"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobindex_publication/edit(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_jobindex_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobindex_publication"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobnet_publication/edit(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_jobnet_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobnet_publication"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/documents/:id/edit(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_recruiters_application_document_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/edit(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/documents/:id/edit(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_recruiters_artificial_candidate_document_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/rounds/:id/edit(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_position_round_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"rounds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters_profiles/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_recruiters_profile_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/edit_requests(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_requests_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"edit_requests"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/saved_profiles/:saved_profile_id/comments/:id/edit(.:format)
   * @param {any} saved_profile_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_saved_profile_comment_path: __jsr.r({"locale":{},"saved_profile_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"saved_profile_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tags/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_tag_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/video_requests/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_video_request_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"video_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/:id/editor_review(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  editor_review_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"editor_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/editor_review(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  editor_review_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"editor_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/applications/:application_id/event_logs/email_logs(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  email_logs_position_application_event_logs_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"event_logs"],[2,[7,"/"],[2,[6,"email_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/artificial_candidates/:artificial_candidate_id/event_logs/email_logs(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  email_logs_position_artificial_candidate_event_logs_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"event_logs"],[2,[7,"/"],[2,[6,"email_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/review/:id/end_review(.:format)
   * @param {any} employees_datum_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  end_review_hr_employees_datum_review_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"end_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/availability_dates/events(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  events_availability_dates_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"availability_dates"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/execute_manual_remerging(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  execute_manual_remerging_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute_manual_remerging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/execute_manual_remerging(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  execute_manual_remerging_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute_manual_remerging"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/export_all(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_all_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/export_all(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_all_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/export(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/export(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/statistics/export(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_statistics_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/extra_data(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  extra_data_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"extra_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/extra_data(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  extra_data_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"extra_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/availability_dates/:id/extra_time_slots(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  extra_time_slots_availability_date_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"availability_dates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"extra_time_slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/extra_time_slots(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  extra_time_slots_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"extra_time_slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_dates/:id/extra_time_slots(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  extra_time_slots_position_interview_date_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_dates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"extra_time_slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/feedback_forms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  feedback_form_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"feedback_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/feedback_forms(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  feedback_forms_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"feedback_forms"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/invites/filter_positions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  filter_positions_invites_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[6,"filter_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters/filter_positions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  filter_positions_recruiters_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters"],[2,[7,"/"],[2,[6,"filter_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/addresses/find_states(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  find_states_addresses_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[6,"find_states"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/ai_position/generate_ai_response(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  generate_ai_response_ai_position_index_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ai_position"],[2,[7,"/"],[2,[6,"generate_ai_response"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/availability_dates/:id/generate_time_slots(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  generate_time_slots_availability_date_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"availability_dates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_time_slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_dates/:id/generate_time_slots(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  generate_time_slots_position_interview_date_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_dates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_time_slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/asset_categories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_asset_categories_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"asset_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/asset_categories/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_asset_category_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"asset_categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/comments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_comment_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/comments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_comments_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_documents/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_contract_document_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_documents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_contract_documents_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/custom_contract_tags/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_custom_contract_tag_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"custom_contract_tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/custom_contract_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_custom_contract_tags_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"custom_contract_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/demo_data(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_demo_data_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"demo_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/departments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_department_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/departments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_departments_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"departments"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/document_folders(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_document_folders_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"document_folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employee_contract_fills/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_contract_fill_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employee_contract_fills"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/import/import(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_import_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/import/delete_imported(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_import_delete_imported_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"delete_imported"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/import/import_files(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_import_files_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"import_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/import/files_template/:organization_id(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_import_files_template_path: __jsr.r({"locale":{},"organization_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"files_template"],[2,[7,"/"],[2,[3,"organization_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/import/template(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_import_template_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/import/verify(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_import_verify_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees/password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_password_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employee_reports/documents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_reports_documents_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employee_reports"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees/sign_in(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employee_session_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/bank_account/:id(.:format)
   * @param {any} employees_datum_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employees_datum_bank_account_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"bank_account"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/bank_account(.:format)
   * @param {any} employees_datum_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employees_datum_bank_account_index_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"bank_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/emergency_contact/:id(.:format)
   * @param {any} employees_datum_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employees_datum_emergency_contact_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"emergency_contact"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/emergency_contact(.:format)
   * @param {any} employees_datum_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employees_datum_emergency_contact_index_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"emergency_contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/review/:id(.:format)
   * @param {any} employees_datum_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employees_datum_review_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/review(.:format)
   * @param {any} employees_datum_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_employees_datum_review_index_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/fields_configuration(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_fields_configuration_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"fields_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/ai_talent_roles/generate(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_generate_ai_talent_role_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"ai_talent_roles"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/import/verify(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_import_verify_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"import"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/manager_onboarding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_manager_onboarding_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"manager_onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/hr_module_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_module_integration_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hr_module_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/my_development(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_my_development_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"my_development"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/my_onboarding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_my_onboarding_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"my_onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboardings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_onboarding_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboardings/:onboarding_id/items/:id(.:format)
   * @param {any} onboarding_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_onboarding_item_path: __jsr.r({"locale":{},"onboarding_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"onboarding_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboarding_templates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_onboarding_template_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboarding_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboarding_templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_onboarding_templates_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboarding_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboardings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_onboardings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboardings"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/organizations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_organization_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/organizations/:organization_id/edit_payroll_settings(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_organization_edit_payroll_settings_path: __jsr.r({"locale":{},"organization_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"edit_payroll_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/organizations/:organization_id/sync_zenegy_data(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_organization_sync_zenegy_data_path: __jsr.r({"locale":{},"organization_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"sync_zenegy_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/organizations/:organization_id/update_payroll_settings(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_organization_update_payroll_settings_path: __jsr.r({"locale":{},"organization_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"update_payroll_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/organizations/:organization_id/zenegy_sync_status(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_organization_zenegy_sync_status_path: __jsr.r({"locale":{},"organization_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"zenegy_sync_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_organizations_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_people_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/permissions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_permission_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/permissions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_permissions_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_person_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:person_id/assets/:id(.:format)
   * @param {any} person_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_person_asset_path: __jsr.r({"locale":{},"person_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:person_id/assets/:asset_id/asset_attachments/:id(.:format)
   * @param {any} person_id
   * @param {any} asset_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_person_asset_asset_attachment_path: __jsr.r({"locale":{},"person_id":{"r":true},"asset_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"asset_attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:person_id/assets/:asset_id/asset_attachments(.:format)
   * @param {any} person_id
   * @param {any} asset_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_person_asset_asset_attachments_path: __jsr.r({"locale":{},"person_id":{"r":true},"asset_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"asset_attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:person_id/assets(.:format)
   * @param {any} person_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_person_assets_path: __jsr.r({"locale":{},"person_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:person_id/custom_reminders/:reminder_id(.:format)
   * @param {any} person_id
   * @param {any} reminder_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_person_custom_reminder_path: __jsr.r({"locale":{},"person_id":{"r":true},"reminder_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[6,"custom_reminders"],[2,[7,"/"],[2,[3,"reminder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:person_id/custom_reminders(.:format)
   * @param {any} person_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_person_custom_reminders_path: __jsr.r({"locale":{},"person_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"person_id"],[2,[7,"/"],[2,[6,"custom_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/reports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_reports_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/review_templates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_review_template_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"review_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/review_templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_review_templates_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"review_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/my_onboarding/items/:id/skip(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_skip_my_onboarding_item_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"my_onboarding"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"skip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/surveys/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_survey_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/surveys/:survey_id/action_plan(.:format)
   * @param {any} survey_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_survey_action_plan_path: __jsr.r({"locale":{},"survey_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"survey_id"],[2,[7,"/"],[2,[6,"action_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/survey_response(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_survey_response_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"survey_response"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/survey_response/status(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_survey_response_status_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"survey_response"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/survey_responses(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_survey_response_update_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"survey_responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/surveys(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_surveys_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_employee_assessments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_talent_employee_assessment_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_employee_assessments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_employees/:employee_id/talent_development_plans(.:format)
   * @param {any} employee_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_talent_employee_development_plans_path: __jsr.r({"locale":{},"employee_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_employees"],[2,[7,"/"],[2,[3,"employee_id"],[2,[7,"/"],[2,[6,"talent_development_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_employees/:employee_id/role_profile(.:format)
   * @param {any} employee_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_talent_employee_role_profile_path: __jsr.r({"locale":{},"employee_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_employees"],[2,[7,"/"],[2,[3,"employee_id"],[2,[7,"/"],[2,[6,"role_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_gap_analyses/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_talent_gap_analysis_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_gap_analyses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_job_families(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_talent_job_families_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_job_families"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_job_families/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_talent_job_family_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_job_families"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_role_profiles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_talent_role_profile_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_role_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/talent_role_profiles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_talent_role_profiles_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"talent_role_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/teams/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_team_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/teams(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_teams_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/my_onboarding/items/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_toggle_my_onboarding_item_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"my_onboarding"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/tree/teams/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_tree_team_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"tree"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/tree/teams(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_tree_teams_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"tree"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/my_onboarding/documents/:id/view(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  hr_view_my_onboarding_document_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"my_onboarding"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/inactive(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  inactive_hr_people_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/invite(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  invite_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/invite(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  invite_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:id/invite_user(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  invite_user_category_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invite_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/notifications/list(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  list_notifications_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /lit/
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lit_root_path: __jsr.r({}, [2,[2,[7,"/"],[6,"lit"]],[7,"/"]]),

  /**
   * Generates rails route to
   * /lit/sources/:id/synchronize(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lit_synchronize_source_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"lit"]],[7,"/"]],[2,[6,"sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"synchronize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/load_categories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  load_categories_categories_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"load_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_requests/load_responsible_list(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  load_responsible_list_contract_requests_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_requests"],[2,[7,"/"],[2,[6,"load_responsible_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/artificial_saved_profiles/:id/log(.:format)
   * @param {any} category_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  log_category_artificial_saved_profile_path: __jsr.r({"locale":{},"category_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"artificial_saved_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/saved_profiles/:id/log(.:format)
   * @param {any} category_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  log_category_saved_profile_path: __jsr.r({"locale":{},"category_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /
   * @param {object | undefined} options
   * @returns {string} route path
   */
  logout_root_path: __jsr.r({"host":{"d":"app.elvium.com"}}, [7,"/"]),

  /**
   * Generates rails route to
   * (/:locale)/notifications/mark_as_seen(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mark_as_seen_notifications_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_as_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/mark_as_signed(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mark_as_signed_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_signed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/mark_signer_as_signed/:signer_id(.:format)
   * @param {any} id
   * @param {any} signer_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mark_signer_as_signed_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"signer_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_signer_as_signed"],[2,[7,"/"],[2,[3,"signer_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/mass_action(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mass_action_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mass_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/mass_actions(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mass_actions_position_recruiters_applications_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"mass_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/merge_fields(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  merge_fields_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"merge_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/merge_fields(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  merge_fields_hr_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"merge_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:id/move_to_category(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  move_to_category_category_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_to_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/positions/:id/move_to_organization(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  move_to_organization_admin_position_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_to_organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/rounds/:id/move_to_round(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  move_to_round_position_round_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"rounds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_to_round"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/notifications/mute(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mute_notifications_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mute"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/position_tags/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_admin_position_tag_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"position_tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/tags/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_admin_tag_path: __jsr.r({"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/comments/new(.:format)
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_application_comment_path: __jsr.r({"locale":{},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/tags/new(.:format)
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_application_tag_path: __jsr.r({"locale":{},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/comments/new(.:format)
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_artificial_candidate_comment_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/tags/new(.:format)
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_artificial_candidate_tag_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_saved_profiles/:artificial_saved_profile_id/comments/new(.:format)
   * @param {any} artificial_saved_profile_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_artificial_saved_profile_comment_path: __jsr.r({"locale":{},"artificial_saved_profile_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_saved_profiles"],[2,[7,"/"],[2,[3,"artificial_saved_profile_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/tags/new_assign(.:format)
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_assign_application_tags_path: __jsr.r({"locale":{},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new_assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/tags/new_assign(.:format)
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_assign_artificial_candidate_tags_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new_assign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_category_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/checklists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_checklist_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"checklists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/checklist_evaluations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_checklist_evaluation_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"checklist_evaluations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/new_communicate_all(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_communicate_all_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_communicate_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_documents/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_contract_document_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_contract_signing_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/custom_contract_tags/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_custom_contract_tag_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"custom_contract_tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_documents/new_duplicate(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_duplicate_contract_documents_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[6,"new_duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/feedback_forms/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_feedback_form_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"feedback_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/new_from_excel(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_from_excel_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"new_from_excel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/new_from_pdf(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_from_pdf_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"new_from_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_documents/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_contract_document_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_contract_signing_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/custom_contract_tags/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_custom_contract_tag_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"custom_contract_tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/departments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_department_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees/password/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_employee_password_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees/sign_in(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_employee_session_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboardings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_onboarding_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboarding_templates/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_onboarding_template_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboarding_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/organizations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_organization_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/permissions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_permission_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_person_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/review_templates/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_review_template_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"review_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/teams/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_hr_team_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/rounds/:id/new_move_to_round(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_move_to_round_position_round_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"rounds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_move_to_round"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/new_notify(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_notify_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"new_notify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/organizations/:organization_id/saved_profiles/new(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_organization_saved_profile_path: __jsr.r({"locale":{},"organization_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/applications/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/application_transfer_operations/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_application_transfer_operation_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"application_transfer_operations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/candidate_email/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_candidate_email_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"candidate_email"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_candidates_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/email_customizations/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_email_customization_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"email_customizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_dates/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_interview_date_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_dates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_reminders/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_interview_reminder_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_reminders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobindex_publication/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_jobindex_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobindex_publication"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/rounds/new(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_position_round_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"rounds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/new_profile(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_profile_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"new_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/new_reopen(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_reopen_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/new_request_documents(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_request_documents_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"new_request_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/saved_profiles/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_saved_profile_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/saved_profiles/:saved_profile_id/comments/new(.:format)
   * @param {any} saved_profile_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_saved_profile_comment_path: __jsr.r({"locale":{},"saved_profile_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"saved_profile_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tags/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_tag_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/video_requests/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_video_request_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"video_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /
   * @param {object | undefined} options
   * @returns {string} route path
   */
  not_found_root_path: __jsr.r({}, [7,"/"]),

  /**
   * Generates rails route to
   * (/:locale)/notifications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  notifications_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/notify(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  notify_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"notify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:id/onboarding_draft(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_draft_hr_person_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"onboarding_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:id/onboarding(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  onboarding_hr_person_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/organizations/:id/organization_redirect(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_redirect_organization_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"organization_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/organizations/:organization_id/saved_profiles/:id(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_saved_profile_path: __jsr.r({"locale":{},"organization_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/organizations/:organization_id/saved_profiles(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_saved_profiles_path: __jsr.r({"locale":{},"organization_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/applications/:id/play_video(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  play_video_position_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"play_video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/artificial_candidates/:id/play_video(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  play_video_position_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"play_video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/applications/:application_id/chat(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_application_chat_messages_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/applications/:application_id/checklists/:id(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_application_checklist_evaluation_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"checklists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/applications/:application_id/checklists(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_application_checklist_evaluations_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"checklists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/applications/:application_id/documents/:id(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_application_document_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/application_transfer_operations/:id(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_application_transfer_operation_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"application_transfer_operations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/application_transfer_operations(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_application_transfer_operations_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"application_transfer_operations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/artificial_candidates/:artificial_candidate_id/checklists/:id(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_artificial_candidate_checklist_evaluation_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"checklists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/artificial_candidates/:artificial_candidate_id/checklists(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_artificial_candidate_checklist_evaluations_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"checklists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/candidate_email(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_candidate_email_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"candidate_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/:id(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_candidates_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/:application_id/chat(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_candidates_application_chat_messages_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/:application_id/new_upload(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_candidates_application_new_upload_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"new_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/:application_id/upload_documents(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_candidates_application_upload_documents_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"upload_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_candidates_applications_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/position_approaches(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_candidates_position_approaches_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"position_approaches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/position_data(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_data_position_recruiters_applications_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"position_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/email_customizations/:id(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_email_customization_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"email_customizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/email_customizations(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_email_customizations_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"email_customizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_dates/:id(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_interview_date_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_dates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_dates(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_interview_dates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_reminders/:id(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_interview_reminder_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_reminders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_reminders(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_interview_reminders_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/job_posting(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_job_posting_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"job_posting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobindex_publication(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_jobindex_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobindex_publication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobnet_publication(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_jobnet_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobnet_publication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/assessments/:id(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_assessment_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/catalyst_integrations(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_catalyst_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"catalyst_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/chat(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_chat_messages_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/documents/:id(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_document_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/documents(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_documents_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/hr_module_integrations(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_hr_module_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"hr_module_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/quinyx_integrations(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_quinyx_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"quinyx_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/sympa_integrations(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_sympa_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"sympa_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/tamigo_integrations(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_tamigo_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"tamigo_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/two_people_integrations(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_two_people_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"two_people_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/visma_integrations(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_visma_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"visma_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:application_id/zenegy_integrations(.:format)
   * @param {any} position_id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_application_zenegy_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"application_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"zenegy_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_applications_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/catalyst_integrations(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidate_catalyst_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"catalyst_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/documents/:id(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidate_document_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/documents(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidate_documents_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/quinyx_integrations(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidate_quinyx_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"quinyx_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/sympa_integrations(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidate_sympa_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"sympa_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/tamigo_integrations(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidate_tamigo_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"tamigo_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/two_people_integrations(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidate_two_people_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"two_people_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:artificial_candidate_id/visma_integrations(.:format)
   * @param {any} position_id
   * @param {any} artificial_candidate_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidate_visma_integrations_path: __jsr.r({"locale":{},"position_id":{"r":true},"artificial_candidate_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"visma_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/organizations/:id/position_redirect(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_redirect_organization_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"position_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/rounds/:id(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_round_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"rounds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/rounds(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  position_rounds_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"rounds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  positions_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_documents/:id/preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_contract_document_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/interview_reminders/preview_email(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_email_position_interview_reminders_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"interview_reminders"],[2,[7,"/"],[2,[6,"preview_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/preview_email(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_email_position_recruiters_applications_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"preview_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_documents/:id/preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_hr_contract_document_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_documents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/job_posting/preview(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_position_job_posting_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"job_posting"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobnet_publication/preview(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_position_jobnet_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobnet_publication"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/surveys/:id/preview_results(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_results_hr_survey_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"surveys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/job_posting/print(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  print_position_job_posting_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"job_posting"],[2,[7,"/"],[2,[6,"print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/:id/proposal_to_candidate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  proposal_to_candidate_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proposal_to_candidate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/proposal_to_employee(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  proposal_to_employee_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"proposal_to_employee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/publish(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  publish_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobnet_publication/publish(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  publish_position_jobnet_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobnet_publication"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobnet_publication/publish_update(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  publish_update_position_jobnet_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobnet_publication"],[2,[7,"/"],[2,[6,"publish_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/quinyx_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  quinyx_integration_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quinyx_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/quinyx_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  quinyx_integration_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quinyx_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboardings/:id/reactivate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reactivate_hr_onboarding_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/read_notifications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  read_notifications_hr_employees_data_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[6,"read_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /(:locale)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recruiter_root_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[1,[3,"locale"]],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recruiters_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters/edit_pwd_from_profile(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recruiters_edit_pwd_from_profile_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters"],[2,[7,"/"],[2,[6,"edit_pwd_from_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters_profiles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recruiters_profile_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters/sign_in/otp(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recruiters_sign_in_otp_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters"],[2,[7,"/"],[2,[6,"sign_in"],[2,[7,"/"],[2,[6,"otp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters/sign_in/otp/confirm_2fa(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recruiters_sign_in_otp_confirm_2fa_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters"],[2,[7,"/"],[2,[6,"sign_in"],[2,[7,"/"],[2,[6,"otp"],[2,[7,"/"],[2,[6,"confirm_2fa"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters/sign_in/otp/setup_2fa(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recruiters_sign_in_otp_setup_2fa_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters"],[2,[7,"/"],[2,[6,"sign_in"],[2,[7,"/"],[2,[6,"otp"],[2,[7,"/"],[2,[6,"setup_2fa"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters/update_pwd_from_profile(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recruiters_update_pwd_from_profile_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters"],[2,[7,"/"],[2,[6,"update_pwd_from_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/reject(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reject_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/reject(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reject_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/edit_requests/:id/reject_request(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reject_request_edit_request_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"edit_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/artificial_saved_profiles/:id/remove_from_category(.:format)
   * @param {any} category_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_from_category_category_artificial_saved_profile_path: __jsr.r({"locale":{},"category_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"artificial_saved_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_from_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:category_id/saved_profiles/:id/remove_from_category(.:format)
   * @param {any} category_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_from_category_category_saved_profile_path: __jsr.r({"locale":{},"category_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_from_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/:id/renew_expired_visma(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  renew_expired_visma_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew_expired_visma"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/renew_expired_visma(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  renew_expired_visma_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew_expired_visma"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/positions/:id/reopen(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reopen_admin_position_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/reopen(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reopen_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/rounds/:id/reorder_rounds(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reorder_rounds_position_round_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"rounds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reorder_rounds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/request_documents(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  request_documents_position_recruiters_artificial_candidates_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[6,"request_documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/resend_invitation_email(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resend_invitation_email_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invitation_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/reset_position(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_position_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/application_process_customization/reset_to_default(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_to_default_application_process_customization_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"application_process_customization"],[2,[7,"/"],[2,[6,"reset_to_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/email_customizations/:id/restore_default_translation(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  restore_default_translation_position_email_customization_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"email_customizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore_default_translation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/applications/:id/revert_delete(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  revert_delete_admin_application_path: __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revert_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/:id/review_result(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  review_result_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review_result"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/review_result(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  review_result_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review_result"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/:id/reviewer_review(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reviewer_review_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reviewer_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/reviewer_review(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reviewer_review_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reviewer_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /(:locale)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  root_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[1,[3,"locale"]],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboardings/:id/save_as_template(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  save_as_template_hr_onboarding_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_as_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/saved_profiles/:saved_profile_id/comments/:id(.:format)
   * @param {any} saved_profile_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  saved_profile_comment_path: __jsr.r({"locale":{},"saved_profile_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"saved_profile_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/saved_profiles/:saved_profile_id/comments(.:format)
   * @param {any} saved_profile_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  saved_profile_comments_path: __jsr.r({"locale":{},"saved_profile_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"saved_profiles"],[2,[7,"/"],[2,[3,"saved_profile_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/:id/send_application(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_application_position_candidates_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_application"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/:id/send_contract(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_contract_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/send_contract(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_contract_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/send_to_editors_and_approvers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_to_editors_and_approvers_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"send_to_editors_and_approvers"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/:id/send_to_editors_and_approvers(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_to_editors_and_approvers_hr_contract_signing_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_editors_and_approvers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/show_action_data(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_action_data_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_action_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/show_action_data(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_action_data_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_action_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:id/show_available_positions(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_available_positions_category_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_available_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/applications/:id/show_cover_letter(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_cover_letter_position_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_cover_letter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/artificial_candidates/:id/show_cover_letter(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_cover_letter_position_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_cover_letter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/applications/:id/show_cv(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_cv_position_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_cv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/artificial_candidates/:id/show_cv(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_cv_position_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_cv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/categories/:id/show_invite_form(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_invite_form_category_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_invite_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/artificial_candidates/:id/show_pdf(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_pdf_position_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/signers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  signers_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"signers"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/signers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  signers_hr_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"signers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/statistics(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistics_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/step_two(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  step_two_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"step_two"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/onboarding_templates/:id/structure(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  structure_hr_onboarding_template_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"onboarding_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"structure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/summary(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  summary_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/summary(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  summary_hr_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/sympa_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sympa_integration_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sympa_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/sympa_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sympa_integration_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sympa_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tags/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tag_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tags_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/tamigo_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tamigo_integration_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tamigo_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/tamigo_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tamigo_integration_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tamigo_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  template_positions_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/c/applications/thanks_for_apply(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thanks_for_apply_position_candidates_applications_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"thanks_for_apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/recruiters/toggle_section(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  toggle_section_recruiters_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"recruiters"],[2,[7,"/"],[2,[6,"toggle_section"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/trigger_document_remerge(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  trigger_document_remerge_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trigger_document_remerge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/trigger_document_remerge(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  trigger_document_remerge_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trigger_document_remerge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/two_people_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  two_people_integration_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"two_people_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/two_people_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  two_people_integration_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"two_people_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/applications/:application_id/tags/:id/unassign(.:format)
   * @param {any} application_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unassign_application_tag_path: __jsr.r({"locale":{},"application_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/artificial_candidates/:artificial_candidate_id/tags/:id/unassign(.:format)
   * @param {any} artificial_candidate_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unassign_artificial_candidate_tag_path: __jsr.r({"locale":{},"artificial_candidate_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"artificial_candidate_id"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/under_menu_notifications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  under_menu_notifications_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"under_menu_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/update_address(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_address_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/application_process_customization/update_banner(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_banner_application_process_customization_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"application_process_customization"],[2,[7,"/"],[2,[6,"update_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/update_brief(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_brief_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_brief"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/update_brief(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_brief_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_brief"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/documents/update_cache(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_cache_documents_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[6,"update_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:employees_datum_id/review/:id/update_comment(.:format)
   * @param {any} employees_datum_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_comment_hr_employees_datum_review_path: __jsr.r({"locale":{},"employees_datum_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"employees_datum_id"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/update_employment_information(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_employment_information_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_employment_information"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/update_file_expiry_date(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_file_expiry_date_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_file_expiry_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/jobnet_publication/update_logo(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_logo_position_jobnet_publication_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"jobnet_publication"],[2,[7,"/"],[2,[6,"update_logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/update_media_module_settings(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_media_module_settings_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_media_module_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/contract_signings/update_multiple(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_multiple_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"update_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/contract_signings/update_multiple(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_multiple_hr_contract_signings_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"contract_signings"],[2,[7,"/"],[2,[6,"update_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/job_posting/update_og_image(.:format)
   * @param {any} position_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_og_image_position_job_posting_path: __jsr.r({"locale":{},"position_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"job_posting"],[2,[7,"/"],[2,[6,"update_og_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/people/:id/update_onboarding(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_onboarding_hr_person_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/document_folders/update_organization_folders(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_organization_folders_hr_document_folders_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"document_folders"],[2,[7,"/"],[2,[6,"update_organization_folders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/update_payroll(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_payroll_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_payroll"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/update_photo(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_photo_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/update_photo(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_photo_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/job_posting_layouts/:job_posting_layout_id/widgets/update_positions(.:format)
   * @param {any} job_posting_layout_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_positions_job_posting_layout_widgets_path: __jsr.r({"locale":{},"job_posting_layout_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"job_posting_layouts"],[2,[7,"/"],[2,[3,"job_posting_layout_id"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/organization_pages/:organization_page_id/widgets/update_positions(.:format)
   * @param {any} organization_page_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_positions_organization_page_widgets_path: __jsr.r({"locale":{},"organization_page_id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"organization_pages"],[2,[7,"/"],[2,[3,"organization_page_id"],[2,[7,"/"],[2,[6,"widgets"],[2,[7,"/"],[2,[6,"update_positions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/update_reminder_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_reminder_settings_hr_employees_data_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[6,"update_reminder_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/update_template(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_template_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/update_weights(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_weights_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_weights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/update_work_dates(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_work_dates_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_work_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/update_work_dates(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_work_dates_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_work_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/update_work_information(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_work_information_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_work_information"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/hr/employees_data/:id/upload_file(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  upload_file_hr_employees_datum_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"hr"],[2,[7,"/"],[2,[6,"employees_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /(:locale)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_root_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[7,"/"],[2,[1,[3,"locale"]],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/timeslots/:id/verify_current(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  verify_current_timeslot_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/timeslots/verify(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  verify_timeslots_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"timeslots"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/video_requests/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  video_request_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"video_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/video_requests(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  video_requests_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"video_requests"],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/view_as_candidate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  view_as_candidate_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"view_as_candidate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/visma_callbacks/documents_signed(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  visma_callback_documents_signed_path: __jsr.r({"locale":{},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visma_callbacks"],[2,[7,"/"],[2,[6,"documents_signed"],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/visma_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  visma_integration_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"visma_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/artificial_candidates/:id/visma_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  visma_integration_position_recruiters_artificial_candidate_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"artificial_candidates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"visma_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:id/weights(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  weights_position_path: __jsr.r({"locale":{},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"weights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * (/:locale)/positions/:position_id/r/applications/:id/zenegy_integration(.:format)
   * @param {any} position_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  zenegy_integration_position_recruiters_application_path: __jsr.r({"locale":{},"position_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.elvium.com"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"positions"],[2,[7,"/"],[2,[3,"position_id"],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"zenegy_integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]])}
,
    });
})();


const routingObject = window.Routes;

const changeRouteLocale = () => {
  const body = document.querySelector('body');
  if (!body) {
    return;
  }
  
  const locale = body.dataset.currentLocale;
  if (routingObject && typeof routingObject.configure === 'function') {
    routingObject.configure({
      default_url_options: {
        locale,
      }
    });
  }
}

export {
  routingObject as Routes,
  changeRouteLocale
};
